/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const eatLessMoveMore = useStore((state) => state.eatLessMoveMore);
  const setEatLessMoveMore = useStore((state) => state.setEatLessMoveMore);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.eatLessMoveMore.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.eatLessMoveMore.subtitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={eatLessMoveMore}
          onChange={(value) => {
            setEatLessMoveMore(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'eat-less-move-more',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'lostWeightGainedBack'}>
            <span>🍽️</span> {t('onboarding.eatLessMoveMore.options.lostWeightGainedBack')}
          </Option>
          <Option value={'tiredHungry'}>
            <span>😩</span> {t('onboarding.eatLessMoveMore.options.tiredHungry')}
          </Option>
          <Option value={'workedWhile'}>
            <span>🏃</span> {t('onboarding.eatLessMoveMore.options.workedWhile')}
          </Option>
          <Option value={'neverTried'}>
            <span>🤷</span> {t('onboarding.eatLessMoveMore.options.neverTried')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
